import { render, staticRenderFns } from "./Picture.vue?vue&type=template&id=3951feb4&scoped=true"
import script from "./Picture.vue?vue&type=script&lang=js"
export * from "./Picture.vue?vue&type=script&lang=js"
import style0 from "./Picture.vue?vue&type=style&index=0&id=3951feb4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3951feb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3951feb4')) {
      api.createRecord('3951feb4', component.options)
    } else {
      api.reload('3951feb4', component.options)
    }
    module.hot.accept("./Picture.vue?vue&type=template&id=3951feb4&scoped=true", function () {
      api.rerender('3951feb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/customComponent/Picture.vue"
export default component.exports